/* OTTR - segmented search, in place of a search PAGE.
 *
 * The icon used to link to routes.search_url, Shopify's stock /search.
 * Nobody chose that; it came with the theme. On a one-product store a whole
 * page for search is the wrong shape - there is almost nothing to search
 * THROUGH - so the icon opens a panel instead.
 *
 * THE PANEL IS TWO LEVELS, not a flat list. Three groups, each holding its
 * own tiles - the shape of the whole store:
 *
 *     Know        what it is, how to use it, people using it
 *     Buy         the thing, the gifts, the spares
 *     After buy   warranty, returns, faults, help
 *
 * KNOW IS TEXT, the other two are pictures. Know is reading - three ways into
 * the same explanation - and a picture beside each one would be decoration
 * pretending to be a choice. Buy and After buy are things, so they get
 * pictures. The `text: true` flag on a group is what switches it.
 *
 * THE ORDER WHEN SOMETHING IS TYPED IS FIXED, and it is the point of the
 * whole component:
 *
 *     1. word suggestions   what you might have meant
 *     2. the groups         where that thing lives
 *     3. live results       the actual pages, from Shopify
 *     4. see all results    the old /search page
 *
 * Empty, it shows what you searched before, then the groups. There is
 * nothing to suggest until there is a query.
 *
 * THE GROUPS ARE THE FLOOR. If a query matches no tile at all, every group
 * comes back rather than an empty panel - with a line saying so, because
 * silently showing everything as though it matched is a lie. The three
 * routes are still the answer even when the words are not.
 *
 * /search IS NOT REMOVED. It is the no-JS path and the deep link, and
 * blocks/ottr-search.liquid now carries the same three groups, so the map is
 * identical wherever you meet it.
 *
 * HARD-CODED, DELIBERATELY AND TEMPORARILY. Everything else here is
 * editor-driven and this should be too - groups, tiles, pictures and
 * vocabulary want to be settings on sections/ottr-head.liquid with pictures
 * from snippets/ottrp-assets.liquid. In the script first so the panel could
 * ship without touching the header Liquid. Whatever changes here has to
 * change in blocks/ottr-search.liquid too, until then.
 *
 * TWO OF US HAVE ALREADY COLLIDED IN THIS FILE. The Know list was cut from
 * six rows to three at 20:50 on 16 Sep and was back to six by 20:56, because
 * the next agent edited a copy fetched before that. RE-FETCH THIS FILE
 * IMMEDIATELY BEFORE WRITING IT, and diff the GROUPS array against what you
 * are about to upload - it is the part of this file most likely to have
 * changed under you.
 */
(function () {
  'use strict';
  if (window.__ottrSearch) return;
  window.__ottrSearch = true;

  /* Must match ottr-navmobile.js and proto-1's burger query. */
  var BURGER = '(max-width: 1040px)';

  var CDN = 'https://cdn.shopify.com/s/files/1/0746/5828/3689/files/';
  function pic(f) { return CDN + f + '&width=320'; }

  /* Pictures were chosen by measurement, not by name: this product's
     photography is mostly light objects on near-white grounds, and a pale
     crop on a white card reads as an empty box. Sampling the centre crop put
     the pack shot at mean luminance 236 against these at 155 and 68. Tiles
     with no verified picture get a tint, which is honest - and the ring on
     .osr__shot carries either case. */
  var IMG = {
    girl:  pic('Girl_holding_Sweep.png?v=1789248514'),
    glove: pic('Sweep_in_glove_compartment.png?v=1789287419')
  };

  /* Every href below was checked against the store's real pages, collections
     and products. A search that points at a 404 is worse than no search at
     all - check again before adding one.

     KNOW IS THREE ROWS, NOT SIX. How it works, Our story and Safety came out
     on 16 Sep, on Anoop's call: the panel is a way INTO the shop, and three
     further essays about the same object are not a route anyone opens a
     search box looking for. Their WORDS stayed - the mechanism went to Sweep
     S1, the cautions to the manual - because a box that stops answering a
     word is a regression even when the page still exists. The pages still
     exist and are still in the footer and the header menu. */
  var GROUPS = [
    { key: 'know', title: 'Know', text: true, tiles: [
      { label: 'Sweep S1', href: '/pages/sweep',
        words: 'sweep s1 about what is how works how it works mechanism inside air flow engineering blow vacuum blower suction motor spec specs power rpm battery runtime charging' },
      { label: 'How to use', href: '/pages/how-to-use-sweep',
        words: 'how to use manual instructions guide setup unbox start nozzle attach filter clean empty safety safe warning caution careful children eyes' },
      { label: 'In the wild', href: '/pages/in-the-wild',
        words: 'in the wild reviews photos posts customers real people instagram reels' }
    ] },
    { key: 'buy', title: 'Buy', tiles: [
      { label: 'Buy Sweep S1', href: '/products/ottr-sweep', img: IMG.girl,
        words: 'buy sweep s1 price cost order purchase cart checkout box kit what is in the box' },
      { label: 'Gift', href: '/pages/gifting',
        words: 'gift gifting present birthday diwali wedding festival wrap' },
      { label: 'Corporate gifting', href: '/pages/corporate-gifting',
        words: 'corporate bulk company employee client hamper quantity invoice gst business' },
      { label: 'Spares & attachments', href: '/collections/spares-attachments',
        words: 'spares attachments nozzle nozzles edge reach spot long brush head fur tool dust collector hepa filter accessories parts replacement' },
      { label: 'Gift card', href: '/pages/gift-card',
        words: 'gift card voucher credit' },
      { label: 'Delivery', href: '/pages/shipping-policy',
        words: 'delivery shipping ship dispatch courier track tracking when arrive days free' },
      { label: 'Saved', href: '/pages/wishlist',
        words: 'saved save wishlist list later favourites favorites' }
    ] },
    { key: 'after', title: 'After buy', tiles: [
      { label: 'Warranty', href: '/pages/warranty', img: IMG.glove,
        words: 'warranty guarantee two year 2 cover covered claim register' },
      { label: 'Returns', href: '/pages/return-a-product',
        words: 'return returns refund exchange seven day 7 send back money cancel' },
      { label: 'Report an issue', href: '/pages/report-an-issue',
        words: 'report issue problem fault faulty broken not working dead repair damage complaint' },
      { label: 'FAQ', href: '/pages/faq',
        words: 'faq question questions answers common help' },
      { label: 'Support', href: '/pages/support',
        words: 'support help service care assistance' },
      { label: 'Contact us', href: '/pages/contact',
        words: 'contact us email phone call reach talk whatsapp message' }
    ] }
  ];

  var VOCAB = ['sweep','sweep s1','buy sweep','price','delivery','shipping','tracking','warranty','returns','refund','report an issue','how to use sweep','nozzles','attachments','spares','brush head','fur tool','dust collector','hepa filter','battery','runtime','charging','cleaning','gift','gift card','corporate gifting','car cleaning','keyboard','desk','pc','blower','vacuum','faq','support','contact','saved'];

  var RKEY = 'ottr.search.recent';
  var MAG = '<circle cx="11" cy="11" r="6.6"/><path d="m16.2 16.2 4.3 4.3"/>';
  var el = {}, open = false, opener = null, t = null, lastQ = '', cur = -1;

  function icon(p) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Browser storage, so: wrapped. It throws outright in a locked-down private
     window, and comes back empty often enough that nothing here may depend on
     it. Recents are a convenience; the panel is complete without them. */
  function recents() {
    try { return JSON.parse(localStorage.getItem(RKEY) || '[]').slice(0, 5); }
    catch (e) { return []; }
  }
  function remember(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    try {
      var l = recents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q);
      localStorage.setItem(RKEY, JSON.stringify(l.slice(0, 5)));
    } catch (e) {}
  }
  function forget() { try { localStorage.removeItem(RKEY); } catch (e) {} }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'osr';
    wrap.setAttribute('hidden', '');
    /* DOM order IS the answer order: recents, words, groups, live, all. */
    wrap.innerHTML =
      '<div class="osr__scrim" aria-hidden="true"></div>' +
      '<div class="osr__card" role="dialog" aria-modal="true" aria-label="Search">' +
        '<form class="osr__bar" role="search" action="/search" method="get">' +
          '<span class="osr__mag" aria-hidden="true">' + icon(MAG) + '</span>' +
          '<input class="osr__in" type="search" name="q" placeholder="Search Ottr" aria-label="Search" aria-controls="osr-out" autocomplete="off">' +
          '<button class="osr__x" type="button" aria-label="Close search">' + icon('<path d="M5 5l14 14M19 5L5 19"/>') + '</button>' +
        '</form>' +
        '<div class="osr__out" id="osr-out">' +
          '<div class="osr__recs" hidden></div>' +
          '<div class="osr__sugs" hidden></div>' +
          '<p class="osr__note" hidden></p>' +
          '<div class="osr__grps"></div>' +
          '<div class="osr__hits" hidden></div>' +
          '<a class="osr__all" hidden href="/search">See all results</a>' +
        '</div>' +
        '<p class="osr__live" aria-live="polite" role="status"></p>' +
      '</div>';
    document.body.appendChild(wrap);

    el.wrap = wrap;
    el.card = wrap.querySelector('.osr__card');
    el.form = wrap.querySelector('.osr__bar');
    el.input = wrap.querySelector('.osr__in');
    el.recs = wrap.querySelector('.osr__recs');
    el.sugs = wrap.querySelector('.osr__sugs');
    el.note = wrap.querySelector('.osr__note');
    el.grps = wrap.querySelector('.osr__grps');
    el.hits = wrap.querySelector('.osr__hits');
    el.all = wrap.querySelector('.osr__all');
    el.out = wrap.querySelector('.osr__out');
    el.say = wrap.querySelector('.osr__live');

    wrap.querySelector('.osr__scrim').addEventListener('click', close);
    wrap.querySelector('.osr__x').addEventListener('click', close);

    el.input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(run, 140);
    });

    /* Enter is the commonest key in a search field and it must not dump
       someone on a results page when the answer is already on screen. It
       goes where the highlight is, or to the first real DESTINATION - word
       chips are skipped, because completing "warr" to "warranty" and making
       you press Enter twice is worse than just opening the warranty page.
       Only when nothing matched does it fall through to /search. */
    el.form.addEventListener('submit', function (e) {
      var go = el.out.querySelector('.is-cur') || el.out.querySelector('[data-go]');
      remember(el.input.value);
      if (!go) return;                 /* let it submit to /search */
      e.preventDefault();
      if (go.hasAttribute('data-term')) { pickTerm(go); return; }
      window.location.href = go.getAttribute('href');
    });

    wrap.addEventListener('keydown', keys);

    /* One listener for the whole panel rather than one per row - the contents
       are rewritten on every keystroke. */
    el.out.addEventListener('click', function (e) {
      var b = e.target.closest('[data-term]');
      if (b) { e.preventDefault(); pickTerm(b); return; }
      var c = e.target.closest('.osr__clear');
      if (c) { e.preventDefault(); forget(); paintRecents(); return; }
      if (e.target.closest('[data-go]')) remember(el.input.value);
    });

    paintGroups(GROUPS);
    paintRecents();
  }

  /* A word suggestion is a query to try, not a place to go: it fills the
     field and re-runs rather than navigating. */
  function pickTerm(b) {
    el.input.value = b.getAttribute('data-term');
    el.input.focus();
    run();
  }

  /* ---- keyboard ---------------------------------------------------- */

  function navs() { return [].slice.call(el.out.querySelectorAll('[data-nav]:not([hidden])')); }

  function mark(i) {
    var l = navs();
    if (!l.length) { cur = -1; return; }
    var was = el.out.querySelector('.is-cur');
    if (was) was.classList.remove('is-cur');
    cur = (i + l.length) % l.length;
    l[cur].classList.add('is-cur');
    l[cur].scrollIntoView({ block: 'nearest' });
  }

  function keys(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      mark(cur === -1 ? (e.key === 'ArrowDown' ? 0 : -1) : cur + (e.key === 'ArrowDown' ? 1 : -1));
      return;
    }

    /* Focus trap. Without it Tab walks straight out of the dialog and into
       the page behind the scrim, which is still there and still clickable to
       a keyboard even though nobody can see it. */
    if (e.key === 'Tab') {
      var f = [].slice.call(el.card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ---- painting ------------------------------------------------------ */

  /* data-nav  = the arrow keys walk it.
     data-go   = Enter will navigate to it.
     A chip carries the first and not the second on purpose: see the submit
     handler above. */
  function chips(list, cls) {
    return list.map(function (v) {
      return '<button class="osr__term ' + cls + '" type="button" data-nav data-term="' + esc(v) + '">' + esc(v) + '</button>';
    }).join('');
  }

  function paintRecents() {
    var r = recents();
    el.recs.innerHTML = r.length
      ? '<span class="osr__cap">Recent<button class="osr__clear" type="button">Clear</button></span>' +
        '<span class="osr__terms">' + chips(r, 'osr__term--rec') + '</span>'
      : '';
    el.recs.hidden = !r.length;
  }

  /* NO loading="lazy" here, and that is not an oversight. These thumbnails
     are built into a position:fixed scroll container that did not exist a
     moment ago; the lazy heuristic never fires for them and every picture
     stays at naturalWidth 0 forever - verified in the browser. There are two
     of them at 320px. The page tiles in blocks/ottr-search.liquid are in
     normal flow and DO keep lazy. */
  function tileHTML(x) {
    return '<a class="osr__tile" data-nav data-go href="' + x.href + '">' +
      (x.img
        ? '<img class="osr__shot" src="' + esc(x.img) + '" alt="" decoding="async">'
        : '<span class="osr__shot osr__shot--tint" aria-hidden="true"></span>') +
      '<span class="osr__tlabel">' + esc(x.label) + '</span>' +
    '</a>';
  }

  /* A text group. Rows, not a grid - and visibly neither a picture tile nor
     a word chip, because it is a third kind of thing and must not be
     mistaken for either. */
  function rowHTML(x) {
    return '<a class="osr__row" data-nav data-go href="' + x.href + '">' +
      '<span>' + esc(x.label) + '</span>' +
      '<svg class="osr__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' +
    '</a>';
  }

  function paintGroups(list) {
    el.grps.innerHTML = list.map(function (g) {
      var body = g.text
        ? '<div class="osr__rows">' + g.tiles.map(rowHTML).join('') + '</div>'
        : '<div class="osr__tiles">' + g.tiles.map(tileHTML).join('') + '</div>';
      return '<section class="osr__grp">' +
        '<h3 class="osr__grpt">' + esc(g.title) + '</h3>' + body +
      '</section>';
    }).join('');
    el.grps.hidden = !list.length;
  }

  function hit(x, q) {
    var hay = (x.words + ' ' + x.label).toLowerCase();
    if (hay.indexOf(q) > -1) return true;
    return q.split(/\s+/).some(function (w) { return w.length > 2 && hay.indexOf(w) > -1; });
  }

  /* ---- the run ------------------------------------------------------- */

  function run() {
    var raw = el.input.value.trim();
    var q = raw.toLowerCase();
    lastQ = q;
    cur = -1;

    /* Clear the previous query's live results NOW rather than when the next
       fetch resolves. Otherwise the rows for the word you just finished
       typing sit under the rows for the word you are typing, and on a slow
       connection they sit there for seconds. */
    el.hits.innerHTML = '';
    el.hits.hidden = true;

    if (!q) {
      el.sugs.hidden = true;
      el.note.hidden = true;
      el.all.hidden = true;
      paintRecents();
      paintGroups(GROUPS);
      el.say.textContent = '';
      return;
    }

    el.recs.hidden = true;

    /* 1. words */
    var sugs = VOCAB.filter(function (v) { return v.indexOf(q) > -1 && v !== q; }).slice(0, 6);
    el.sugs.innerHTML = sugs.length
      ? '<span class="osr__cap">Did you mean</span><span class="osr__terms">' + chips(sugs, '') + '</span>'
      : '';
    el.sugs.hidden = !sugs.length;

    /* 2. groups, filtered to matching tiles. The text flag has to travel with
       the group or a filtered Know comes back as pictures. */
    var got = GROUPS.map(function (g) {
      return {
        key: g.key, title: g.title, text: g.text,
        tiles: g.tiles.filter(function (x) { return hit(x, q); })
      };
    }).filter(function (g) { return g.tiles.length; });

    var none = !got.length;
    paintGroups(none ? GROUPS : got);

    /* Say so rather than showing everything as though it matched. */
    el.note.textContent = none ? 'Nothing here matches “' + raw + '”. These three still might.' : '';
    el.note.hidden = !none;

    /* 4. the way out, always available once there is a query */
    el.all.href = '/search?q=' + encodeURIComponent(raw);
    el.all.hidden = false;

    var n = got.reduce(function (a, g) { return a + g.tiles.length; }, 0);
    el.say.textContent = none ? 'No direct match' : n + (n === 1 ? ' place' : ' places') + ' to go';

    /* 3. live, when it arrives */
    live(q);
  }

  /* Shopify's own predictive endpoint, so results are real rather than a list
     kept in sync by hand. Allowed to fail: the words and the groups are
     already on screen either way. */
  function live(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,page,article&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (lastQ !== q) return;
        var r = (j && j.resources && j.resources.results) || {};
        var rows = [].concat(r.products || [], r.pages || [], r.articles || []);
        el.hits.innerHTML = rows.length
          ? '<span class="osr__cap">On the site</span>' + rows.map(function (x) {
              return '<a class="osr__hit" data-nav data-go href="' + esc(x.url) + '">' +
                (x.featured_image && x.featured_image.url
                  ? '<img src="' + esc(x.featured_image.url) + '" alt="" decoding="async">'
                  : '<span class="osr__dot" aria-hidden="true"></span>') +
                '<span>' + esc(x.title) + '</span></a>';
            }).join('')
          : '';
        el.hits.hidden = !rows.length;
        if (rows.length) el.note.hidden = true;
      })
      .catch(function () { el.hits.hidden = true; });
  }

  /* ---- open and close ------------------------------------------------ */

  /* SYNCHRONOUS, not inside requestAnimationFrame. rAF does not fire in a
     throttled or backgrounded tab, and that once left the panel open with
     `is-on` never applied - a fully focusable, completely invisible dialog -
     and focus still on <body>. */
  function show(from, seed) {
    if (!el.wrap) build();
    opener = from || null;
    el.wrap.hidden = false;
    document.documentElement.classList.add('osr-on');
    el.wrap.classList.add('is-on');
    open = true;
    if (seed) { el.input.value = seed; run(); } else { paintRecents(); }
    try { el.input.focus({ preventScroll: true }); el.input.select(); } catch (e) {}
  }

  function close() {
    if (!el.wrap || !open) return;
    open = false;
    cur = -1;
    el.wrap.classList.remove('is-on');
    document.documentElement.classList.remove('osr-on');
    setTimeout(function () { if (!open) el.wrap.hidden = true; }, 220);
    el.input.value = '';
    run();
    if (opener && document.contains(opener)) { try { opener.focus(); } catch (e) {} }
    opener = null;
  }

  /* ---- wiring -------------------------------------------------------- */

  /* The icon stays a real link to /search, so with this script blocked the
     old page is still there. We only take the click. */
  function wire() {
    document.querySelectorAll('a[href*="/search"]:not([data-osr])').forEach(function (a) {
      if (a.closest('.osr')) return;
      if (!/search/i.test(a.getAttribute('aria-label') || '') && !a.closest('.icons')) return;
      a.setAttribute('data-osr', '1');
      a.addEventListener('click', function (e) { e.preventDefault(); show(a); });
    });

    /* /search draws the same three groups, and its field opens the panel
       rather than being a second, lesser search.

       CLICK, not focus. Closing the panel returns focus to whatever opened
       it - and a focus handler here would see that, reopen, and trap the
       person in a panel they cannot close. Tabbing to the field still gets
       the plain form, which works on its own and submits to this same page. */
    var field = document.querySelector('.searchform input[name="q"]');
    if (field && !field.hasAttribute('data-osr')) {
      field.setAttribute('data-osr', '1');
      field.addEventListener('click', function () {
        if (open) return;
        show(field, field.value);
      });
    }

    placeEntry();
  }

  /* ---- the way in from the menu -------------------------------------- */

  /* One button, two homes.

     DESKTOP: inside the mega-menu, between the listings and the two banner
     cards. It sat above the columns before, where it was the first thing in
     a panel you opened to read the columns - a search box offered before
     anyone has seen what there is to search for.

     SHEET: lifted out of the scrolling area entirely, into its own pinned
     row directly above the foot bar. The sheet then reads bottom-up as
     Buy and the socials, then search, then the links - the two fixed things
     under the thumb and the long list above them, scrolling on its own.
     That is why the row is a child of .drop rather than of .drop-in: only a
     flex child of the sheet can stay put while .drop-in scrolls. */
  function entry() {
    var b = document.querySelector('.osr-open');
    if (b) return b;
    b = document.createElement('button');
    b.type = 'button';
    b.className = 'osr-open';
    b.innerHTML = icon(MAG) + '<span>Search</span>';
    b.addEventListener('click', function () {
      var burger = document.querySelector('.burger[aria-expanded="true"]');
      if (burger) burger.click();
      show(b);
    });
    return b;
  }

  function placeEntry() {
    var drop = document.getElementById('mainmenu');
    if (!drop) return;
    var b = entry();

    if (window.matchMedia(BURGER).matches) {
      var row = drop.querySelector('.drop-searchrow');
      if (!row) {
        row = document.createElement('div');
        row.className = 'drop-searchrow';
      }
      if (b.parentElement !== row) row.appendChild(b);

      /* Before the foot bar, whichever of us built our piece first. */
      var bar = drop.querySelector('.drop-bar');
      if (row.parentElement !== drop || (bar && row.nextElementSibling !== bar)) {
        if (bar) drop.insertBefore(row, bar);
        else drop.appendChild(row);
      }
      return;
    }

    var cols = drop.querySelector('.drop-cols');
    if (!cols) return;
    if (b.previousElementSibling !== cols) cols.parentNode.insertBefore(b, cols.nextSibling);
    var stale = drop.querySelector('.drop-searchrow');
    if (stale && !stale.contains(b)) stale.remove();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !open) {
      var n = document.activeElement;
      if (n && (n.tagName === 'INPUT' || n.tagName === 'TEXTAREA' || n.isContentEditable)) return;
      e.preventDefault();
      show(null);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();

  /* The button has to move when the header changes mode, and the sheet is
     rebuilt under us on a section reload. */
  var mq = window.matchMedia(BURGER);
  if (mq.addEventListener) mq.addEventListener('change', placeEntry);
  else if (mq.addListener) mq.addListener(placeEntry);
  document.addEventListener('shopify:section:load', wire);
  setTimeout(placeEntry, 700);
})();